import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
import _imports_0 from '@/assets/Mantaraya.png';
const _hoisted_1 = { class: "min-h-screen bg-ewhite-50 px-6 py-8" };
const _hoisted_2 = { class: "mx-auto flex max-w-5xl flex-col gap-8" };
const _hoisted_3 = { class: "flex items-center justify-between" };
const _hoisted_4 = { class: "flex items-center gap-3" };
const _hoisted_5 = ["alt"];
const _hoisted_6 = { class: "text-2xl font-bold text-eblack-900" };
const _hoisted_7 = { class: "text-sm text-eblack-500" };
const _hoisted_8 = {
    key: 0,
    class: "rounded-lg border bg-white p-8 text-center text-eblack-600"
};
const _hoisted_9 = {
    key: 1,
    class: "rounded-lg border border-red-200 bg-red-50 p-6 text-red-700"
};
const _hoisted_10 = {
    key: 2,
    class: "grid gap-4 md:grid-cols-2"
};
const _hoisted_11 = { class: "mb-4 flex h-10 w-10 items-center justify-center rounded-lg bg-eorange-100" };
const _hoisted_12 = { class: "text-lg font-semibold text-eblack-900" };
const _hoisted_13 = { class: "mt-1 text-sm text-eblack-500" };
const _hoisted_14 = ["onClick"];
const _hoisted_15 = { class: "mb-4 flex h-10 w-10 items-center justify-center rounded-lg bg-egreen-100" };
const _hoisted_16 = { class: "flex items-start justify-between gap-3" };
const _hoisted_17 = { class: "text-lg font-semibold text-eblack-900" };
const _hoisted_18 = { class: "mt-1 text-sm text-eblack-500" };
const _hoisted_19 = { class: "rounded-full bg-ewhite-100 px-2 py-1 text-xs capitalize text-eblack-600" };
const _hoisted_20 = {
    key: 1,
    class: "rounded-lg border border-ewhite-200 bg-white p-8 text-center text-eblack-600 md:col-span-2"
};
import { computed } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { IconBuilding, IconWorldCog } from "@tabler/icons-vue";
import { useAuthStore } from "@/domains/auth";
import { useOrganizationContextSwitch, } from "@/domains/organization";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrganizationSelector',
    setup(__props) {
        const router = useRouter();
        const { t } = useI18n();
        const authStore = useAuthStore();
        const contextSwitch = useOrganizationContextSwitch();
        const isLoading = computed(() => authStore.isLoading);
        const errorMessage = computed(() => authStore.error);
        const visibleMemberships = computed(() => authStore.activeMemberships);
        const isEmpty = computed(() => !authStore.isSuperAdmin && visibleMemberships.value.length === 0);
        const emptyMessage = computed(() => t("shell.organization_selector.empty"));
        function selectMembershipOrg(membership) {
            contextSwitch.switchToMembershipOrg(membership);
            router.push("/admin");
        }
        function enterGlobalConsole() {
            contextSwitch.enterGlobalConsole();
            router.push("/admin/global/organizations");
        }
        async function handleLogout() {
            await authStore.logout();
            router.push("/login");
        }
        function formatOrgType(orgType) {
            return orgType
                ? t(`shell.organization_selector.org_types.${orgType}`)
                : t("shell.organization_selector.org_types.default");
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("header", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("img", {
                                src: _imports_0,
                                alt: _ctx.$t('admin.auto.emanta'),
                                class: "h-11 w-11"
                            }, null, 8, _hoisted_5),
                            _createElementVNode("div", null, [
                                _createElementVNode("h1", _hoisted_6, _toDisplayString(_unref(t)("shell.organization_selector.title")), 1),
                                _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)("shell.organization_selector.description")), 1)
                            ])
                        ]),
                        _createElementVNode("button", {
                            class: "rounded-lg border px-4 py-2 text-sm text-eblack-700",
                            onClick: handleLogout
                        }, _toDisplayString(_unref(t)("shell.organization_selector.logout")), 1)
                    ]),
                    (isLoading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(t)("shell.organization_selector.loading")), 1))
                        : (errorMessage.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(errorMessage.value), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                (_unref(authStore).isSuperAdmin)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "rounded-lg border border-eorange-200 bg-white p-5 text-left shadow-sm transition hover:border-eorange-400 hover:shadow-md",
                                        onClick: enterGlobalConsole
                                    }, [
                                        _createElementVNode("div", _hoisted_11, [
                                            _createVNode(_unref(IconWorldCog), { class: "h-5 w-5 text-eorange-600" })
                                        ]),
                                        _createElementVNode("h2", _hoisted_12, _toDisplayString(_unref(t)("shell.organization_selector.global_console.title")), 1),
                                        _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(t)("shell.organization_selector.global_console.description")), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleMemberships.value, (membership) => {
                                    return (_openBlock(), _createElementBlock("button", {
                                        key: membership.org_id,
                                        type: "button",
                                        class: "rounded-lg border border-ewhite-200 bg-white p-5 text-left shadow-sm transition hover:border-egreen-400 hover:shadow-md",
                                        onClick: ($event) => (selectMembershipOrg(membership))
                                    }, [
                                        _createElementVNode("div", _hoisted_15, [
                                            _createVNode(_unref(IconBuilding), { class: "h-5 w-5 text-egreen-700" })
                                        ]),
                                        _createElementVNode("div", _hoisted_16, [
                                            _createElementVNode("div", null, [
                                                _createElementVNode("h2", _hoisted_17, _toDisplayString(membership.org_name), 1),
                                                _createElementVNode("p", _hoisted_18, _toDisplayString(membership.role_label), 1)
                                            ]),
                                            _createElementVNode("span", _hoisted_19, _toDisplayString(formatOrgType(membership.org_type)), 1)
                                        ])
                                    ], 8, _hoisted_14));
                                }), 128)),
                                (isEmpty.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(emptyMessage.value), 1))
                                    : _createCommentVNode("", true)
                            ]))
                ])
            ]));
        };
    }
});
